function setAspectRatio(iFrameElement, ratio) {
    iFrameElement.style.height = Math.min(((iFrameElement.offsetWidth / ratio[0]) * ratio[1]), window.innerHeight) + 'px';
}